import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { customerService } from 'services/customerService';
import { apiUrls } from 'constants/apiUrls';
import { toast } from 'react-toastify';
import { commonMessage } from 'constants/commonMessage';
import { DataNotFound } from 'components/Alerts/Alerts';
import { appRoutesUrls } from 'constants/appRoutesUrls';
import InvoiceItemList from '../Invoice/InvoiceItemList';

const CustomerInvoiceItemList = () => {
    const pageTitle = "Customer";
    const { id } = useParams();
    const [message, setMessage] = useState();
    const [customer, setCustomer] = useState();
    const [isLoader, setIsLoader] = useState(false);

    useEffect(() => {
        if (id > 0) {
            setIsLoader(true);
            customerService.getCustomer(apiUrls.getCustomer(id)).then((res) => {
                setIsLoader(false);
                if (res)
                    setCustomer(res);
                else {
                    setMessage(commonMessage.notFound(pageTitle));
                    toast.warn(commonMessage.notFound(pageTitle));
                }
            }).catch((err) => setIsLoader(false));
        }
    }, [id]);

    return (
        <>
            {customer && customer.id > 0 ?
                (<InvoiceItemList customerId={customer.id} customerName={customer.name} />) :
                (message && <DataNotFound title={pageTitle}>
                    Click here to go <Link to={appRoutesUrls.customers()}>Gustomers</Link>
                </DataNotFound>)
            }
        </>
    )
}

export default CustomerInvoiceItemList;